import './index.scss'

import React from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'

const bem = new BEMHelper('container')

export default function Container({
  children,
  size,
  className,
  node,
  ...props
}) {
  const Node = node

  return (
    <Node {...props} {...bem('', { [size]: size }, className)}>
      {children}
    </Node>
  )
}

Container.propTypes = {
  children: T.any,
  size: T.string,
  className: T.string,
  node: T.string,
  style: T.object,
}

Container.defaultProps = {
  node: 'div',
}
